module.exports = {
    development: {
        url: 'https://backend-portfolio-gules.vercel.app/auth/form',
        url_test: 'http://localhost:3001/auth/form'
    }
}